export const TEAMTOKEN = "R2SvUfH1T3nD6jY8aLpW0zCkQ7gM4E5XxV9iBcNlK"
export const CITYTOKEN = "pp6Rq3X63R2c6puMMDRhXsv23kuDyec2h5wssbn6t"
